import { MinusCircle } from "lucide-react";

export default function ColorInput({
  label,
  value,
  onChange,
  canBeTransparent = false,
}) {
  const isTransparent = value === "transparent" || value === "none";

  return (
    <div className="ctrl !flex-col !items-start gap-1.5">
      <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
        {label}
      </span>
      <div className="flex items-center gap-2 w-full">
        <div className="relative w-8 h-8 rounded-lg overflow-hidden border border-gray-200 shrink-0 shadow-sm">
          <input
            type="color"
            value={isTransparent ? "#ffffff" : value || "#000000"}
            onChange={(e) => onChange(e.target.value)}
            className="absolute -inset-1 w-[150%] h-[150%] cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
            disabled={isTransparent}
          />
          {isTransparent && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-50 pointer-events-none">
              <div className="w-full h-[1px] bg-red-400 rotate-45"></div>
            </div>
          )}
        </div>

        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="ctrl-text flex-1 bg-white border border-gray-200 rounded-lg px-2 py-1.5 text-xs focus:ring-1 focus:ring-indigo-500 outline-none transition-all"
          placeholder="#000000"
        />

        {canBeTransparent && (
          <button
            type="button"
            onClick={() => onChange(isTransparent ? "#ffffff" : "transparent")}
            className={`flex items-center justify-center p-1.5 rounded-lg border transition-all ${
              isTransparent
                ? "bg-indigo-50 border-indigo-200 text-indigo-600 shadow-inner"
                : "bg-white border-gray-200 text-gray-400 hover:text-gray-600 hover:bg-gray-50"
            }`}
            title={isTransparent ? "Clear transparency" : "Set to transparent"}
          >
            <MinusCircle size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
